import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import 'react-perfect-scrollbar/dist/css/styles.css';

import MyPATApp from './MyPATApp';

import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store';
import 'react-perfect-scrollbar/dist/css/styles.css';

ReactDOM.render(
	<Provider store={store}>
		{/* <PersistGate loading={null} persistor={persistor}> */}
		<MyPATApp />
		{/* </PersistGate> */}
	</Provider>
	,
	document.getElementById('app-container')
);

serviceWorker.unregister();

store.dispatch({ type: 'LOAD_DATA' });
